import { FormSchema } from "../../../interfaces/components/form";
import { FormComponent } from "../../../components/form/FormComponents";

export const addNewDoctor: FormSchema = {
  type: "object",
  properties: {
    title: {
      label: "Title",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Title",
        options: [
          { label: "Dr.", value: "Dr." },
          { label: "Prof.", value: "Prof." },
          { label: "Mr.", value: "Mr." },
          { label: "Ms.", value: "Ms." },
          { label: "Mrs.", value: "Mrs." },
        ],
      },
    },
    firstName: {
      label: "First Name",
      type: "string",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Enter first name",
        type: "text",
      },
    },
    middleName: {
      label: "Middle Name",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Enter middle name",
        type: "text",
      },
    },
    lastName: {
      label: "Last Name",
      type: "string",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Enter last name",
        type: "text",
      },
    },

    dateOfBirth: {
      label: "Date of Birth",
      type: "date",
      required: false,
      component: FormComponent.DatePicker,
      componentProps: {
        placeholder: "Select date of birth",
        showTime: false,
      },
    },
    gender: {
      label: "Gender",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Gender",
        options: [
          { label: "Male", value: "Male" },
          { label: "Female", value: "Female" },
          { label: "Other", value: "Other" },
          { label: "Prefer not to say", value: "Prefer not to say" },
        ],
      },
    },
    email: {
      label: "Email Address",
      type: "email",
      format: "email",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "doctor@hospital.com",
        type: "email",
      },
    },
    phone: {
      label: "Phone Number",
      type: "string",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "(555) 123-4567",
        type: "tel",
      },
      validator: [
        {
          regex:
            "^\\+?[1-9]\\d{1,14}$|^\\([0-9]{3}\\)\\s[0-9]{3}-[0-9]{4}$|^[0-9]{3}-[0-9]{3}-[0-9]{4}$",
          message: "Please enter a valid phone number",
        },
      ],
    },
    emergencyContact: {
      label: "Emergency Contact",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "(555) 987-6543",
        type: "tel",
      },
    },
    address: {
      label: "Address",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "123 Medical Way, City, State 12345",
        type: "text",
      },
    },
    department: {
      label: "Department",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Department",
        options: [
          { label: "Internal Medicine", value: "Internal Medicine" },
          { label: "Surgery", value: "Surgery" },
          { label: "Pediatrics", value: "Pediatrics" },
          { label: "Emergency Medicine", value: "Emergency Medicine" },
          { label: "Radiology", value: "Radiology" },
          { label: "Pathology", value: "Pathology" },
          { label: "Anesthesiology", value: "Anesthesiology" },
          { label: "Psychiatry", value: "Psychiatry" },
          {
            label: "Obstetrics & Gynecology",
            value: "Obstetrics & Gynecology",
          },
          { label: "Cardiology", value: "Cardiology" },
          { label: "Neurology", value: "Neurology" },
          { label: "Orthopedics", value: "Orthopedics" },
        ],
      },
    },
    specialization: {
      label: "Specialization",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Specialization",
        options: [
          { label: "Cardiology", value: "Cardiology" },
          { label: "Neurology", value: "Neurology" },
          { label: "Orthopedics", value: "Orthopedics" },
          { label: "Dermatology", value: "Dermatology" },
          { label: "Oncology", value: "Oncology" },
          { label: "Gastroenterology", value: "Gastroenterology" },
          { label: "Pulmonology", value: "Pulmonology" },
          { label: "Endocrinology", value: "Endocrinology" },
          { label: "Nephrology", value: "Nephrology" },
          { label: "Rheumatology", value: "Rheumatology" },
          { label: "Infectious Disease", value: "Infectious Disease" },
          { label: "Hematology", value: "Hematology" },
          { label: "General Practice", value: "General Practice" },
        ],
      },
    },
    employmentStatus: {
      label: "Employment Status",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Employment Status",
        options: [
          { label: "Full-time", value: "Full-time" },
          { label: "Part-time", value: "Part-time" },
          { label: "Contract", value: "Contract" },
          { label: "Resident", value: "Resident" },
          { label: "Fellow", value: "Fellow" },
          { label: "Per Diem", value: "Per Diem" },
          { label: "Consulting", value: "Consulting" },
        ],
      },
    },
    licenseNumber: {
      label: "Medical License Number",
      type: "string",
      required: true,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "MD123456789",
        type: "text",
      },
      validator: [
        {
          regex: "^[A-Z]{2}[0-9]{6,12}$",
          message:
            "License number should start with 2 letters followed by 6-12 digits",
        },
      ],
    },
    npiNumber: {
      label: "NPI Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "1234567890",
        type: "text",
        helperText: "10-digit National Provider Identifier",
      },
      validator: [
        {
          regex: "^[0-9]{10}$",
          message: "NPI number must be exactly 10 digits",
        },
      ],
    },
    deaNumber: {
      label: "DEA Number",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "AS1234567",
        type: "text",
        helperText: "Drug Enforcement Administration registration number",
      },
      validator: [
        {
          regex: "^[A-Z]{2}[0-9]{7}$",
          message: "DEA number should be 2 letters followed by 7 digits",
        },
      ],
    },
    hireDate: {
      label: "Hire Date",
      type: "date",
      required: false,
      component: FormComponent.DatePicker,
      componentProps: {
        placeholder: "Select hire date",
        showTime: false,
      },
    },
    workSchedule: {
      label: "Work Schedule",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Work Schedule",
        mode: "multiple",
        options: [
          { label: "Monday", value: "Monday" },
          { label: "Tuesday", value: "Tuesday" },
          { label: "Wednesday", value: "Wednesday" },
          { label: "Thursday", value: "Thursday" },
          { label: "Friday", value: "Friday" },
          { label: "Saturday", value: "Saturday" },
          { label: "Sunday", value: "Sunday" },
          { label: "Night Shift", value: "Night Shift" },
          { label: "On-Call", value: "On-Call" },
        ],
      },
    },
    supervisingPhysician: {
      label: "Supervising Physician",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Dr. Jane Doe",
        type: "text",
      },
    },
    medicalSchool: {
      label: "Medical School",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Harvard Medical School",
        type: "text",
      },
    },
    graduationYear: {
      label: "Graduation Year",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Graduation Year",
        options: [
          { label: "2024", value: "2024" },
          { label: "2023", value: "2023" },
          { label: "2022", value: "2022" },
          { label: "2021", value: "2021" },
          { label: "2020", value: "2020" },
          { label: "2019", value: "2019" },
          { label: "2018", value: "2018" },
          { label: "2017", value: "2017" },
          { label: "2016", value: "2016" },
          { label: "2015", value: "2015" },
          { label: "2014", value: "2014" },
          { label: "2013", value: "2013" },
          { label: "2012", value: "2012" },
          { label: "2011", value: "2011" },
          { label: "2010", value: "2010" },
          { label: "2009", value: "2009" },
          { label: "2008", value: "2008" },
          { label: "2007", value: "2007" },
          { label: "2006", value: "2006" },
          { label: "2005", value: "2005" },
          { label: "2004", value: "2004" },
          { label: "2003", value: "2003" },
          { label: "2002", value: "2002" },
          { label: "2001", value: "2001" },
          { label: "2000", value: "2000" },
          { label: "Before 2000", value: "Before 2000" },
        ],
      },
    },
    residency: {
      label: "Residency Program",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Johns Hopkins Hospital",
        type: "text",
      },
    },
    fellowship: {
      label: "Fellowship Program",
      type: "string",
      required: false,
      component: FormComponent.Input,
      componentProps: {
        placeholder: "Mayo Clinic",
        type: "text",
      },
    },
    boardCertifications: {
      label: "Board Certifications",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Board Certifications",
        mode: "multiple",
        options: [
          {
            label: "American Board of Internal Medicine",
            value: "American Board of Internal Medicine",
          },
          {
            label: "American Board of Surgery",
            value: "American Board of Surgery",
          },
          {
            label: "American Board of Pediatrics",
            value: "American Board of Pediatrics",
          },
          {
            label: "American Board of Emergency Medicine",
            value: "American Board of Emergency Medicine",
          },
          {
            label: "American Board of Radiology",
            value: "American Board of Radiology",
          },
          {
            label: "American Board of Pathology",
            value: "American Board of Pathology",
          },
          {
            label: "American Board of Anesthesiology",
            value: "American Board of Anesthesiology",
          },
          {
            label: "American Board of Psychiatry and Neurology",
            value: "American Board of Psychiatry and Neurology",
          },
          {
            label: "American Board of Obstetrics and Gynecology",
            value: "American Board of Obstetrics and Gynecology",
          },
          {
            label: "American Board of Orthopedic Surgery",
            value: "American Board of Orthopedic Surgery",
          },
        ],
      },
    },
    languages: {
      label: "Languages Spoken",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Languages",
        mode: "multiple",
        options: [
          { label: "English", value: "English" },
          { label: "Spanish", value: "Spanish" },
          { label: "French", value: "French" },
          { label: "German", value: "German" },
          { label: "Italian", value: "Italian" },
          { label: "Portuguese", value: "Portuguese" },
          { label: "Chinese (Mandarin)", value: "Chinese (Mandarin)" },
          { label: "Japanese", value: "Japanese" },
          { label: "Korean", value: "Korean" },
          { label: "Arabic", value: "Arabic" },
          { label: "Hindi", value: "Hindi" },
          { label: "Russian", value: "Russian" },
          { label: "Dutch", value: "Dutch" },
          { label: "Swedish", value: "Swedish" },
          { label: "Other", value: "Other" },
        ],
      },
    },
    insuranceAccepted: {
      label: "Insurance Plans Accepted",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Insurance Plans",
        mode: "multiple",
        options: [
          { label: "Medicare", value: "Medicare" },
          { label: "Medicaid", value: "Medicaid" },
          { label: "Blue Cross Blue Shield", value: "Blue Cross Blue Shield" },
          { label: "Aetna", value: "Aetna" },
          { label: "Cigna", value: "Cigna" },
          { label: "UnitedHealth", value: "UnitedHealth" },
          { label: "Humana", value: "Humana" },
          { label: "Kaiser Permanente", value: "Kaiser Permanente" },
          { label: "Anthem", value: "Anthem" },
          { label: "Tricare", value: "Tricare" },
          { label: "Workers' Compensation", value: "Workers' Compensation" },
          { label: "Self-Pay", value: "Self-Pay" },
        ],
      },
    },
    clinicLocations: {
      label: "Clinic Locations",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Clinic Locations",
        mode: "multiple",
        options: [
          { label: "Main Campus", value: "Main Campus" },
          { label: "Downtown Clinic", value: "Downtown Clinic" },
          { label: "North Branch", value: "North Branch" },
          { label: "South Branch", value: "South Branch" },
          { label: "East Wing", value: "East Wing" },
          { label: "West Wing", value: "West Wing" },
          { label: "Outpatient Center", value: "Outpatient Center" },
          { label: "Emergency Department", value: "Emergency Department" },
          { label: "Surgical Center", value: "Surgical Center" },
          { label: "Specialty Clinic", value: "Specialty Clinic" },
        ],
      },
    },
    emergencyPrivileges: {
      label: "Emergency Privileges",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Emergency Privileges",
        options: [
          { label: "Yes", value: "true" },
          { label: "No", value: "false" },
        ],
      },
    },
    status: {
      label: "Status",
      type: "string",
      required: false,
      component: FormComponent.Select,
      componentProps: {
        placeholder: "Select Status",
        options: [
          { label: "Active", value: "Active" },
          { label: "Inactive", value: "Inactive" },
          { label: "On Leave", value: "On Leave" },
          { label: "Suspended", value: "Suspended" },
          { label: "Terminated", value: "Terminated" },
        ],
      },
    },
  },
};
